import {
    Datagrid,
    downloadCSV,
    NumberField,
    SimpleList,
    TextField,
} from 'react-admin';
import { Stack, TextField as MUITextField } from '@mui/material';
import jsonexport from 'jsonexport/dist';
import { InfiniteList } from '@components/InfiniteList';
import { useMediaQuery, Theme } from '@mui/material';
import { UploadButton } from '@components/UploadButton';
import { dataObject } from '@src/object.type';
import env from '@src/environment';

const PriceInfo = (purchasePrice: number, sellingPrice: number) => {
    return (
        <Stack direction="row" spacing={2} sx={{ marginTop: 2 }}>
            <MUITextField
                label="Harga Beli"
                value={purchasePrice}
                variant="outlined"
                InputProps={{
                    readOnly: true,
                }}
            />
            <MUITextField
                label="Harga Jual"
                value={sellingPrice}
                variant="outlined"
                InputProps={{
                    readOnly: true,
                }}
            />
        </Stack>
    );
};

export const GoodsList = () => {
    const isSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('sm')
    );

    const exporter = (goods: dataObject[]) => {
        const goodsForExport = goods.map(g => {
            const { code, name, purchasePrice, sellingPrice, stock, category } =
                g;
            return {
                data_kode_barang: code,
                data_nama_barang: name,
                data_harga_beli: purchasePrice,
                data_harga_jual: sellingPrice,
                data_stok: stock,
                kategori: category,
            };
        });

        jsonexport(
            goodsForExport,
            {
                headers: [
                    'data_kode_barang',
                    'data_nama_barang',
                    'data_harga_beli',
                    'data_harga_jual',
                    'data_stok',
                    'kategori',
                ],
            },
            (err, csv) => {
                downloadCSV(
                    csv,
                    `data_barang_${new Date().toLocaleString(env.localFormat)}`
                );
            }
        );
    };

    return (
        <InfiniteList uploadButton={<UploadButton />} exporter={exporter}>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.name}
                    secondaryText={record =>
                        PriceInfo(record.sellingPrice, record.purchasePrice)
                    }
                    tertiaryText={record => record.category}
                />
            ) : (
                <Datagrid>
                    <TextField source="category" />
                    <TextField source="code" />
                    <TextField source="name" />
                    <NumberField
                        source="purchasePrice"
                        locales={env.localFormat}
                        textAlign="right"
                    />
                    <NumberField
                        source="sellingPrice"
                        locales={env.localFormat}
                        textAlign="right"
                    />
                    <NumberField
                        source="stock"
                        locales={env.localFormat}
                        textAlign="right"
                    />
                </Datagrid>
            )}
        </InfiniteList>
    );
};
